import styled from "styled-components";
import {
	FONT_WT_MEDIUM,
	COLOR_TEXT_PRIMARY_B2C,
	DESKTOP_SM_BP,
	TABLET_BP,
	MOBILE_L_BP,
	DESKTOP_M_BP,
	FONT_WT_LIGHT,
} from "@website-builder/utilities-index";

export const LearningPathWrapper = styled.div`
	padding: 60px 0;
	.container {
		display: flex;
		justify-content: center;
		padding: 10px 0;
		margin: 0 auto;
	}
	.contentWrapper {
		h6 {
			font-size: 28px;
			font-weight: ${FONT_WT_MEDIUM};
			margin: 0;
			line-height: 32px;
			color: ${COLOR_TEXT_PRIMARY_B2C};
		}
		width: 500px;
		margin-right: 80px;
		.content {
			width: 470px;
			font-size: 16px;
			font-weight: ${FONT_WT_LIGHT};
			line-height: 26px;
			margin-top: 40px;
			color: ${COLOR_TEXT_PRIMARY_B2C};
		}
		.bulletContainer {
			margin-top: 30px;
			.curriculumButton {
				margin-top: 20px;
				width: 400px;
			}
		}
	}
	.imageWrapper {
		width: 470px;
		text-align: center;
		.learners {
			h6 {
				font-size: 28px;
				font-weight: ${FONT_WT_MEDIUM};
				margin: 0;
				line-height: 32px;
				color: ${COLOR_TEXT_PRIMARY_B2C};
				text-align: left;
			}
			.learnersThumbnailContainer {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				list-style-type: none;
				padding-left: 0;
				margin-top: 30px;
				.learnerThumbnail {
					display: flex;
					align-items: center;
					border-radius: 50%;
					height: 88px;
					margin-bottom: 10px;
					margin-right: 18px;
					overflow: hidden;
					width: 88px;
					.learnerImage {
						width: 88px;
						height: 88px;
					}
				}
			}
		}
		.authorContainer {
			margin-top: 40px;
			h6 {
				font-size: 28px;
				font-weight: ${FONT_WT_MEDIUM};
				margin: 0;
				line-height: 32px;
				color: ${COLOR_TEXT_PRIMARY_B2C};
				text-align: left;
			}
			.avatar {
				margin-top: 20px;
				.avatarDetailsWrapper {
					display: flex;
					margin-top: 27px;
					align-items: center;
					.avatarImage {
						img {
							height: 66px;
							width: 66px;
							border-radius: 50%;
						}
					}
					.avatarDetails {
						display: flex;
						flex-wrap: wrap;
						margin-left: 12px;
						.name {
							font-size: 16px;
							font-weight: ${FONT_WT_MEDIUM};
							margin-bottom: 5px;
							width: 100%;
							text-align: left;
							color: ${COLOR_TEXT_PRIMARY_B2C};
						}
						.title {
							font-size: 16px;
							font-weight: ${FONT_WT_LIGHT};
							margin-bottom: 5px;
							width: 100%;
							text-align: left;
							font-style: italic;
							color: ${COLOR_TEXT_PRIMARY_B2C};
						}
					}
				}
				.avatarQuote {
					text-align: left;
					font-size: 16px;
					font-weight: ${FONT_WT_LIGHT};
					line-height: 26px;
					color: ${COLOR_TEXT_PRIMARY_B2C};
					margin-top: 20px;
				}
			}
		}
	}

	@media only screen and (max-width: ${DESKTOP_M_BP}px) {
		padding: 30px 10px;
		.container {
			flex-flow: wrap;
		}
		.contentWrapper {
			width: 100%;
			margin-right: 0;
			text-align: center;
			h6 {
				text-align: center;
			}
			.content {
				text-align: left;
				width: 100%;
			}
		}
		.imageWrapper {
			width: 50%;
			margin-top: 40px;
			.learners {
				h6 {
					text-align: center;
				}
				.learnersThumbnailContainer {
					justify-content: center;
					.learnerThumbnail {
						height: 66px;
						width: 66px;
						margin-right: 6px;
						margin-left: 6px;
						img {
							height: 66px;
							width: 66px;
						}
						.learnerImage {
							width: 66px;
							height: 66px;
						}
					}
				}
			}
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 30px 20px;
		.imageWrapper {
			width: 100%;
		}
		.curriculumButton {
			width: 100% !important;
		}
	}
`;
